import { Button, Form, Select } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { addRemitters, sendRemitterOtp2 } from "../../../ApiServices/Apifun";
import VerifyModal from "../../../Common/VerifyModal";
import { Globalendpoints } from "../../../ApiServices/global";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setselectedTab } from "../../../Store/B2bslice";
import {
  aadharPattern,
  deviceOptions,
  dispatchtoast,
  getLocalStorageItem,
  handleSubmitForAeps,
  mantrairisPIDOPTS,
  mobilePattern,
  parseXml,
  pincodePattern,
  startekPIDOPTS,
} from "../../../Utils";

import CommonInput from "../../../Common/CommonInput";
import VerifyModal2 from "../../../Common/VerifyModal2";
import axios from "axios";
import { xml2json } from "../../../Utils/xml2json";

const RemitterReg2 = () => {
  const dispatch = useDispatch();
  const [btnLoading, setBtnLoading] = useState(false);
  const [form] = Form.useForm();
  const formref = useRef();
  const [isOpen, setIsOpen] = useState(false);
  const [response, setResponse] = useState({});
  const memberServices = useSelector((state) => state.B2B.memberServices);
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(setselectedTab("4"));
    if (!memberServices.includes("4")) {
      navigate("/not-Available");
    }
  }, []);
  const handleAdd = (val) => {
    setBtnLoading(true);
  };
  const formatXmlToSingleQuote = (xmlString) => {
    // 1️⃣ Remove all newlines and extra spaces between tags
    let compact = xmlString.replace(/\r?\n|\r/g, "").replace(/\s{2,}/g, " ");

    // 2️⃣ Replace double quotes with single quotes
    compact = compact.replace(/"/g, "'");

    // 3️⃣ Trim any leftover whitespace
    return compact.trim();
  };
  const capture = (val, port = 11100) => {
    setBtnLoading(true);
    console.log(val, port, "port value");
    axios({
      method: "CAPTURE", // Set the custom request method here
      url:
        val.device === "morpho"
          ? `https://localhost:${port}/capture`
          : val.device === "startek"
          ? "https://localhost:11200/rd/capture"
          : `https://127.0.0.1:${port}/rd/capture`,
      data:
        val.device === "morpho"
          ? `<PidOptions ver="1.0"><Opts fCount="1" fType="2" iCount="" iType="" pCount="" pType="" format="0" pidVer="2.0" timeout="10000" otp="" env="P" wadh='${"18f4CEiXeXcfGXvgWA/blxD+w2pw7hfQPY45JMytkPw="}' posh=""/></PidOptions>`
          : val.device === "mantra"
          ? `<?xml version="1.0"?> <PidOptions ver="1.0"> <Opts fCount="1" fType="2" iCount="0" pCount="0" format="0" pidVer="2.0" timeout="20000" posh="UNKNOWN" env="P" wadh='${"18f4CEiXeXcfGXvgWA/blxD+w2pw7hfQPY45JMytkPw="}'/> <CustOpts><Param name="mantrakey" value="" /></CustOpts> </PidOptions>`
          : val.device === "startek"
          ? startekPIDOPTS
          : mantrairisPIDOPTS,
      headers: {
        "Content-Type": "text/xml",
        Accept: "text/xml",
      },
    })
      .then((response) => {
        const parsed = parseXml(response.data);
        const xmltojson = JSON.parse(xml2json(parsed).replace("undefined", ""));
        if (xmltojson.PidData.Resp.errCode !== "0") {
          dispatchtoast(
            `Failed to fetch fingerprint because of ${xmltojson.PidData.Resp.errInfo}`,
            true
          );
          setBtnLoading(false);
        } else {
          dispatchtoast("Fingerprint Captured SuccessFully");
          const parsed = parseXml(response.data);
          console.log(response.data, "parsed", typeof response.data);
          // const xmltojson = JSON.parse(
          //   xml2json(parsed).replace("undefined", "")
          // );

          // const { dpId, rdsId, rdsVer, mi, mc, dc } =
          //   xmltojson.PidData.DeviceInfo;
          // const { ci } = xmltojson.PidData.Skey;
          // const { Hmac } = xmltojson.PidData;
          // const payload = {
          //   reference_key: referenceKey,
          //   mobileNumber: val?.mobile,
          //   latitude: getLocalStorageItem("latitude"),
          //   longitude: getLocalStorageItem("longitude"),
          //   srno: xmltojson?.PidData?.additional_info
          //     ? Array.isArray(xmltojson.PidData?.additional_info?.Param)
          //       ? xmltojson.PidData?.additional_info?.Param[0]?.value
          //       : xmltojson?.PidData?.additional_info?.Param.value
          //     : Array.isArray(
          //         xmltojson?.PidData.DeviceInfo.additional_info?.Param
          //       )
          //     ? xmltojson?.PidData?.DeviceInfo?.additional_info?.Param[0]?.value
          //     : xmltojson?.PidData?.DeviceInfo?.additional_info?.Param?.value,
          //   dpId: dpId ? dpId : 0,
          //   rdsId: rdsId ? rdsId : 0,
          //   rdsVer: rdsVer ? rdsVer : 0,
          //   dc: dc ? dc : 0,
          //   mi: mi ? mi : 0,
          //   mc: mc ? mc : 0,
          //   ci: ci ? ci : 0,
          //   ts: "",
          //   skey: xmltojson.PidData.Skey["#text"],
          //   hmac: Hmac ? Hmac : 0,
          //   pidData: xmltojson.PidData.Data["#text"],
          // };
          const formdata = new FormData();
          formdata.append("request_type", 2);
          formdata.append("accessmode", "WEB");
          formdata.append("pid_data", formatXmlToSingleQuote(response.data));
          formdata.append("latitude", getLocalStorageItem("latitude"));
          formdata.append("longitude", getLocalStorageItem("longitude"));
          Object.entries(val).forEach(([key, value]) =>
            formdata.append(key, value)
          );
          sendRemitterOtp2(formdata)
            .then((res) => {
              if (res.status) {
                setResponse(res.data);
                setIsOpen(true);
                //  navigate("/dmt/verifyOtp",{state:{mobile:fields.mobile,otp_refrence_id:res.data.otprefrenceid}})
              }
            })
            .catch((err) => console.log(err))
            .finally((err) => setBtnLoading(false));
        }
      })
      .catch((error) => {
        setBtnLoading(false);
      });
  };
  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-1 place-items-start">
        <div className="prepaid animate-slide-in w-full lg:w-1/2 bg-white shadow-normal  rounded-3xl p-5">
          <p className="font-bold text-[15px] mb-2">Add Remitter</p>
          <Form
            name="basic"
            form={form}
            ref={formref}
            onFinishFailed={(err) => console.log(err)}
            // onFinish={(val) => handleAdd(val)}
            onFinish={(val) => handleSubmitForAeps(val, capture, setBtnLoading)}
          >
            <Form.Item
              name={`mobile`}
              label={"Mobile Number"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Enter Mobile Number!",
                },
                {
                  pattern: mobilePattern,
                  message: "Please enter a valid mobile number",
                },
                {
                  whitespace: true,
                  message: "Field cannot contain only blank spaces",
                },
              ]}
            >
              <CommonInput
                placeholder="Enter Your Mobile Number!"
                name="mobile"
              />
            </Form.Item>{" "}
            <Form.Item
              name={`aadhaar_number`}
              label={"Aadhaar Number"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Enter aadhaar mo.!",
                },
                {
                  pattern: aadharPattern,
                  message: "Please enter valid aadhaar",
                },
              ]}
            >
              <CommonInput
                onInput={(e) => {
                  const value = e.target.value.replace(/\D/g, "");
                  e.target.value = value;
                }}
                placeholder="Enter Your First Name!"
                name="first_name"
              />
            </Form.Item>{" "}
            {/* <Form.Item
              name={`pin_code`}
              label={"Pin Code"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Enter PinCode!",
                },
                {
                  pattern: pincodePattern,
                  message: "Please enter a valid pin-code",
                },
                {
                  whitespace: true,
                  message: "Field cannot contain only blank spaces",
                },
              ]}
            >
              <CommonInput placeholder="Enter PinCode!" name="pin_code" />
            </Form.Item>{" "} */}
            <Form.Item
              name={`device`}
              label={"Select Device"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Select any one device!",
                },
              ]}
            >
              <Select
                placeholder="Select a device"
                className="w-full mt-2"
                options={deviceOptions}
              />
            </Form.Item>{" "}
            <Form.Item>
              <Button
                htmlType="submit"
                loading={btnLoading}
                className="bg-primary mt-2 w-full border-none rounded-md h-9 text-center text-white flex justify-center items-center font-bold text-md cursor-pointer"
              >
                Submit
              </Button>
            </Form.Item>{" "}
          </Form>
        </div>
      </div>
      {isOpen && (
        <VerifyModal2
          isOpen={isOpen}
          from="register"
          setIsOpen={setIsOpen}
          endpoint={Globalendpoints.verifyRemitterRegOtp2}
          otherFields={{
            mobile: form.getFieldValue("mobile"),
            stateresp: response.stateresp,
            ekyc_id: response?.ekyc_id,
          }}
        />
      )}
    </>
  );
};

export default RemitterReg2;